export const getTimeRemaining = (endTime) => {
  if (!endTime) return null;
  
  // Handle microseconds and add UTC indicator
  let cleanedEndTime = endTime;
  if (typeof endTime === 'string') {
    if (endTime.includes('.')) {
      cleanedEndTime = endTime.replace(/(\.\d{3})\d+/, '$1');
    }
    if (!cleanedEndTime.endsWith('Z') && !cleanedEndTime.includes('+')) {
      cleanedEndTime += 'Z';
    }
  }
  
  const total = new Date(cleanedEndTime).getTime() - Date.now();
  
  if (total <= 0) return { expired: true };
  
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  
  return { total, days, hours, minutes, seconds, expired: false };
};

export const formatTimeRemaining = (timeData) => {
  if (!timeData) return '';
  if (timeData.expired) return 'Completed';
  
  const { days, hours, minutes, seconds } = timeData;
  
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;
  return `${seconds}s`;
};